<template>  
    <div class="container project">
        <b-row>

            <b-col md="4">
                <h2>Choose A Talent</h2>

                <b-form-group label="Application">
                    <multiselect 
                        v-model="application" 
                        :allowEmpty="false" 
                        :options="applications" 
                        label="name"
                        selectLabel=""
                        selectedLabel=""
                        deselectLabel=""
                        >
                    </multiselect>
                </b-form-group>

                <b-form-group label="Gender">
                    <b-form-checkbox id="gender-male" v-model="gender" name="gender"> Male</b-form-checkbox>
                    <b-form-checkbox id="gender-female" v-model="gender" name="gender"> Female</b-form-checkbox>
                </b-form-group>
            </b-col>

            <b-col md="8">
                <talent-card v-for="talent in $store.getters['talent/items']" :talent="talent" :key="talent.uuid"></talent-card>
            </b-col>

        </b-row>

        <new-project-modal></new-project-modal>

    </div>
</template>
<script>
    import TalentCard from '../TalentCard'
    import AudioFormatModal from '../modals/AudioFormatModal'
    import NewProjectModal from './NewProjectModal'
    import Multiselect from 'vue-multiselect'

    import {mapGetters} from 'vuex'
    export default {
        components: {Multiselect, TalentCard, AudioFormatModal, NewProjectModal},
        data() {
            return {
                application: {
                    name: null,
                    id: null
                },
                talentName: null,
                format: {
                    name: null,
                    id: null
                },
                talents: [],

                selectedLanguage: null
            };
        },
        methods: {
            ...mapGetters({
                applications: 'tag/applications',
                languages: 'tag/languages'
            }),
            selectLanguage: function(language) {
                this.selectedLanguage = language;
            },
        },
        computed: {
            
        },
        created() {
            
        },
        mounted () {
            if (!this.$store.state.project.application || 
                this.$store.state.project.application && this.$store.state.project.application.name != 'Telephony/IVR') {
                this.$bvModal.show('start-project-modal')
            }
        }
    };
</script>


// WEBPACK FOOTER //
// prompts/components/project/Talent.vue